import { render } from '@testing-library/react';
import React, { Component, useEffect, useState, useLayoutEffect } from 'react'
import { Link, useLocation } from 'react-router-dom';
import { GeoserverGetCapabilities } from '../../services/geoserver/GeoserverCapabilities';
import Meses from '../../services/Meses';
import NoticiasApi from '../../services/robinhood/NoticiasApi';
import ValoresApi from '../../services/robinhood/ValoresApi';

export default function MenuRelatorio() {

  const meses = Meses;
  const [anos, setAnos] = useState([]);
  const [menu, setMenu] = useState(new Date().getFullYear());

  useEffect(() => {
    // start();
  }, [])

  const start = async () => {
    new ValoresApi().anos().then(response => {
      const anosMap = response.map(ano => ano.ano);
      setAnos(anosMap.reverse());
    });
  }

  const handlerMenu = (ano) => {
    if (menu == ano)
      setMenu(null);
    else
      setMenu(ano);
  }

  return (
    <>
      <div className="menu">
        <ul className="list">
          <li className="header">
            <strong> <i className='zmdi zmdi-calendar m-r-5'></i>  &nbsp;PERÍODOS DISPONÍVEIS </strong>
          </li>
          {anos.map(ano => {
            return <li key={Math.random()} className={menu == ano ? 'active open' : ''} onClick={() => handlerMenu(ano)}>
              <Link to={'/extratos/relatorio'} key={Math.random()} title={ano} state={{ periodo: { 'ano': ano, }, 'key': Math.random() }} className="waves-effect waves-classic" >
                <span> {ano} </span>
              </Link>
            </li>
          }
          )}
        </ul>
      </div>
    </>
  );

}
